<div style="padding: 16px">
  <h1 style="text-align: center">Competitions</h1>
  <br />
  <ng-container *ngIf="activeCompetitions?.data">
    <div style="padding: 16px 15%">
      <ng-container *ngIf="activeCompetitions!.data!.length == 0">
        <h2 style="text-align: center">There are no active competitions.</h2>
      </ng-container>
      <ng-container *ngFor="let item of activeCompetitions!.data!">
        <a target="_blank" [href]="item.website ?? '#'">
          <mat-card>
            <mat-card-content>
              <div fxLayout="row wrap">
                <div fxFlex="100">
                  <img mat-card-image [src]="item.bannerUrl" />
                </div>
                <div fxFlex="100">
                  <h2 style="text-align: center">
                    <strong>{{ item.tagLine }}</strong>
                  </h2>
                </div>
                <div fxFlex="100">
                  <div
                    style="text-align: center; color: #323475 !important"
                    [innerHTML]="decode(item.body!)"
                  ></div>
                </div>
                <div fxFlex="100"></div>
              </div>
            </mat-card-content>
          </mat-card>
        </a>
        <br />
        <br />
      </ng-container>
    </div>
  </ng-container>
</div>
